__turbopack_context__.v({
  "aboutIconWiggle": "about-section-module-scss-module__3kQm3G__aboutIconWiggle",
  "card": "about-section-module-scss-module__3kQm3G__card",
  "cardCorner": "about-section-module-scss-module__3kQm3G__cardCorner",
  "cardGlow": "about-section-module-scss-module__3kQm3G__cardGlow",
  "cardHover": "about-section-module-scss-module__3kQm3G__cardHover",
  "cardIcon": "about-section-module-scss-module__3kQm3G__cardIcon",
  "cardText": "about-section-module-scss-module__3kQm3G__cardText",
  "cardTitle": "about-section-module-scss-module__3kQm3G__cardTitle",
  "contactItem": "about-section-module-scss-module__3kQm3G__contactItem",
  "container": "about-section-module-scss-module__3kQm3G__container",
  "quoteBg": "about-section-module-scss-module__3kQm3G__quoteBg",
  "quoteBlock": "about-section-module-scss-module__3kQm3G__quoteBlock",
  "quoteGradient": "about-section-module-scss-module__3kQm3G__quoteGradient",
  "quoteInner": "about-section-module-scss-module__3kQm3G__quoteInner",
  "quoteSubtitle": "about-section-module-scss-module__3kQm3G__quoteSubtitle",
  "quoteText": "about-section-module-scss-module__3kQm3G__quoteText",
  "section": "about-section-module-scss-module__3kQm3G__section",
  "skillCard": "about-section-module-scss-module__3kQm3G__skillCard",
  "skillCardGlow": "about-section-module-scss-module__3kQm3G__skillCardGlow",
  "skillCardHover": "about-section-module-scss-module__3kQm3G__skillCardHover",
  "skillDesc": "about-section-module-scss-module__3kQm3G__skillDesc",
  "skillIcon": "about-section-module-scss-module__3kQm3G__skillIcon",
  "skillTitle": "about-section-module-scss-module__3kQm3G__skillTitle",
  "skillsGrid": "about-section-module-scss-module__3kQm3G__skillsGrid",
  "subtitle": "about-section-module-scss-module__3kQm3G__subtitle",
  "summaryGrid": "about-section-module-scss-module__3kQm3G__summaryGrid",
  "techList": "about-section-module-scss-module__3kQm3G__techList",
  "techTag": "about-section-module-scss-module__3kQm3G__techTag",
  "title": "about-section-module-scss-module__3kQm3G__title",
  "titleBlock": "about-section-module-scss-module__3kQm3G__titleBlock",
  "titleLine": "about-section-module-scss-module__3kQm3G__titleLine",
});
